import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Alert,
  AlertIcon,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
} from '@chakra-ui/react';
import { adminApi, ApiError } from '../lib/api';
import { WelcomeShell } from '../components/page/WelcomeShell';

export function AdminLoginPage() {
  const navigate = useNavigate();
  // `/admin?tab=health` (an alert email's link) survives the sign-in (M67).
  const { search } = useLocation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await adminApi.login(username, password);
      navigate(`/admin${search}`, { replace: true });
    } catch (err) {
      setError(
        err instanceof ApiError && err.code === 'INVALID_CREDENTIALS'
          ? 'Invalid credentials'
          : 'Login failed. Is the server running?'
      );
      setLoading(false);
    }
  };

  return (
    <WelcomeShell
      title="System root"
      subtitle="The admin panel for this Twinden server."
      footer="Family members sign in with a passkey on the main page, not here."
    >
      <form onSubmit={handleSubmit}>
        <VStack spacing={4} align="stretch">
          {error && (
            <Alert status="error" borderRadius="xl">
              <AlertIcon />
              {error}
            </Alert>
          )}
          <FormControl isRequired>
            <FormLabel>Username</FormLabel>
            <Input
              h="52px"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              autoFocus
            />
          </FormControl>
          <FormControl isRequired>
            <FormLabel>Password</FormLabel>
            <Input
              h="52px"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </FormControl>
          <Button type="submit" h="56px" fontSize="17px" isLoading={loading}>
            Sign in
          </Button>
        </VStack>
      </form>
    </WelcomeShell>
  );
}
